import React from 'react';

interface ChartCardProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  loading?: boolean;
  className?: string;
  actions?: React.ReactNode;
  fillHeight?: boolean;
}

const ChartCard: React.FC<ChartCardProps> = ({
  title,
  subtitle,
  children,
  loading = false,
  className = '',
  actions,
  fillHeight = false,
}) => {
  const shell = fillHeight
    ? `flex flex-col h-full min-h-0 ${className}`
    : className;

  if (loading) {
    return (
      <div
        className={`bg-white border border-[#E5E9EB] rounded-3xl p-6 ${shell}`}
      >
        <div
          className={`animate-pulse ${fillHeight ? 'flex flex-col flex-1 min-h-0' : ''}`}
        >
          <div className="flex items-center justify-between mb-6 shrink-0">
            <div>
              <div className="bg-gray-200 h-6 w-48 rounded mb-2" />
              {subtitle && <div className="bg-gray-200 h-4 w-32 rounded" />}
            </div>
          </div>
          <div
            className={`bg-gray-200 rounded-2xl ${fillHeight ? 'flex-1 min-h-[280px]' : 'h-64'}`}
          />
        </div>
      </div>
    );
  }

  return (
    <div
      className={`bg-white border border-[#E5E9EB] rounded-3xl p-6 hover:shadow-md transition-shadow ${shell}`}
    >
      <div className="flex items-center justify-between mb-6 shrink-0">
        <div>
          <h3 className="text-lg font-semibold text-[#172B4D]">{title}</h3>
          {subtitle && (
            <p className="text-sm text-[#6B778C] mt-1">{subtitle}</p>
          )}
        </div>
        {actions && <div>{actions}</div>}
      </div>
      <div className={fillHeight ? 'flex flex-col flex-1 min-h-0' : undefined}>
        {children}
      </div>
    </div>
  );
};

export default ChartCard;
